import React from "react";
import { makeStyles } from "@mui/styles";
import ArrowForwardContact from "src/assets/iconsSvg/arrowForwardContact";
import { colors } from "src/colors/colors";
import logoMbDefault from "../../assets/contract/logo-mb-hover.png";
import logoMbHover from "../../assets/contract/logo-mb-white-hover.png";
import { useNavigate } from "react-router-dom";
import PATH from "src/routes/route-path";
import { QueryInquiryBill } from "../../api/queryInquiryBill";
import { useCheckLoading } from "../../providers/checkLoadingProvider";
import PopupService from '../../utils/PopupService';
import {
  IResponseInquiryPolicy,
  IDataContractNumber,
} from "../../interface/inquiryPolicy/responseInquiryPolicy";
import { goBack } from "src/utils";
import i18n from 'src/lang/i18n';
import { FR_HEADER } from "src/const/const-from-env";
import ProductName from "src/screens/InfoPay/step2/component/productName";

interface PropsI {
  data: IResponseInquiryPolicy;
  nextStep?: () => void;
  dataBody?: any;
  valueRecaptcha:string
}
const useStyles = makeStyles((theme) => {
  return {
    container: {
      [theme.breakpoints.up("xl")]: {
      },
    },
    containerContract: {
      ...theme.custom.flexBox.flexBetWeen,
      flexWrap: "wrap",
      [theme.breakpoints.down("sm")]: {
        display: "block",
      },
    },
    contractItem: {
      ...theme.custom.flexBox.flexBetWeen,
      background: colors.white,
      width: "49%",
      padding: "20px 24px",
      borderRadius: "16px",
      color: colors.text.main,
      border: `2px solid #E0E0E0`,
      position: "relative",
      marginBottom: "16px",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
        marginBottom: "16px",
        padding: "20px 16px",
      },
    },
    contentItem: {
      ...theme.custom.flexBox.flexAlignItemsCenter,
      marginBottom: "14px",
      [theme.breakpoints.down("md")]: {
        marginBottom: "16px",
      },
    },
    contentItemContainer: {
    },
    containerIconForward: {
      minWidth: "40px",
      height: "40px",
      ...theme.custom.flexBox.flexCenterCenter,
      borderRadius: "50%",
      background: "#009FFF",
      [theme.breakpoints.down("md")]: {
        transform: "scale(0.7)",
      },
    },
    textDesc: {
      fontSize: "12px",
      lineHeight: "18px",
      minWidth: "136px",
    },
    textTitle: {
      fontWeight: 600,
      lineHeight: "24px",
      fontSize: "14px",
      [theme.breakpoints.down("md")]: {
        fontSize: "12px",
        lineHeight: "18px",
      },
    },
    textHeader: {
      fontWeight: 600,
      lineHeight: "20px",
      fontSize: "12px",
      marginBottom: "8px",
    },
    containerBg: {
      position: "absolute",
      top: "0",
      right: "0",
      bottom: "0",
      opacity: "0.5",
    },
    highLightContract: {
      background: "#009FFF",
      color: colors.white,
      cursor: "pointer",
    },
    highLightIcon: {
      border: `1px solid ${colors.white}`,
    },
  };
});

interface IParams {
  frSystm?: string
}
const ContractInsuranceDocumentPerson = ({
  data,
  valueRecaptcha,
  dataBody,
}: PropsI) => {
  const params: IParams = Object.fromEntries(
    new URLSearchParams(location.search.split("?")[1])
  );
  const [idContract, setIdContract] = React.useState();
  const { setIsLoading } = useCheckLoading();
  const navigate = useNavigate();
  const classes = useStyles();
  const setIdContractHanlde = (id) => {
    setIdContract(id);
  };
  const onNextStep = (dataSend) => {
    callQueryContrac(dataSend);
  };
  const callQueryContrac = async (dataSend) => {
    setIsLoading(true);
    const body = {
      insuranceContractNumber: dataSend.policyNumber,
      bornPeopleBuyInsurance: dataBody.bornPeopleBuyInsurance,
      bornPeopleUseInsurance: dataBody.bornPeopleUseInsurance,
    };
    try {
      const res = await QueryInquiryBill(body, valueRecaptcha, params?.frSystm);
      res.data.msgSts.code === "000" ? navigate(PATH.INFOPAY, { state: {data: res.data.data, frSystm: params?.frSystm ? params?.frSystm : FR_HEADER} }) : null
    } catch (error) {
      console.log("error", error);
      PopupService.instance.current.open({
        visible: true,
        content: error.message,
        onOk: () => {
          PopupService.instance.current.close();
          goBack();
        },
      });
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className={classes.container}>
      <div className={classes.textHeader}>
        Tìm thấy {data?.data?.length} kết quả
      </div>
      <div className={classes.containerContract}>
        {data?.data?.map((contract: IDataContractNumber, index) => {
          return (
            <div
              key={index}
              className={`${classes.contractItem} ${
                contract.policyNumber === idContract
                  ? classes.highLightContract
                  : ""
              }`}
              onMouseMove={() => setIdContractHanlde(contract.policyNumber)}
              onMouseOut={() => setIdContractHanlde(0)}
              onClick={() => onNextStep(contract)}
            >
              <div className={classes.containerBg}>
                <img
                  src={
                    contract.policyNumber === idContract
                      ? logoMbHover
                      : logoMbDefault
                  }
                  alt=""
                  style={{ height: "100%" }}
                />
              </div>
              <div className={classes.contentItemContainer}>
                <div className={classes.contentItem}>
                  <div className={classes.textDesc}>Số hợp đồng bảo hiểm:</div>
                  <div className={classes.textTitle}>
                    {contract.policyNumber}
                  </div>
                </div>
                <div className={classes.contentItem}>
                  <div className={classes.textDesc}>Bên mua Bảo hiểm: </div>
                  <div className={classes.textTitle}>{contract.ph_name}</div>
                </div>
                <div
                  className={classes.contentItem}
                  style={{ marginBottom: "0" }}
                >
                  <div className={classes.textDesc}>Sản phẩm Bảo hiểm: </div>
                  <ProductName value={contract.prdName} textAlign={"left"} />
                </div>
              </div>
              <div
                className={`${classes.containerIconForward} ${
                  contract.policyNumber === idContract
                    ? classes.highLightIcon
                    : ""
                }`}
              >
                <ArrowForwardContact />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ContractInsuranceDocumentPerson;
